import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-playVideo",
  "use": "icon-playVideo-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-playVideo\"><defs><style type=\"text/css\"></style></defs><path d=\"M247.69999971 178.14285723v610.54285693c0 46.54285752 51.42857168 74.82857168 91.07142891 49.5l481.41428554-305.27142803c36.68571386-22.97142862 36.68571386-76.02857138 0-99.60000029L338.77142862 128.6c-39.6-25.28571445-91.07142891 2.99999971-91.07142891 49.54285723z\" p-id=\"12942\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol